export type VersionInfo = {
  version: string;
  commit?: string;
};

// Injected at image build time (Dockerfile_nginx); CRA only exposes variables prefixed with REACT_APP_.
export const CLIENT_VERSION: VersionInfo = {
  version: process.env.REACT_APP_VERSION || "dev",
  commit: process.env.REACT_APP_COMMIT || "",
};

/** "2.1.0" becomes "v2.1.0"; a non numeric version such as "latest" is kept as is. The commit is shortened. */
export const formatVersion = ({ version, commit }: VersionInfo): string => {
  const label = /^\d/.test(version) ? `v${version}` : version;
  return commit ? `${label} (${commit.slice(0, 7)})` : label;
};
